import { Button } from '@/components/ui/button';
import { Trash2, X } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useState } from 'react';

interface FlexEBulkActionsProps {
  selectedCount: number;
  onClearSelection: () => void;
  onBulkDelete: () => void;
  isDeleting: boolean;
}

export default function FlexEBulkActions({
  selectedCount,
  onClearSelection,
  onBulkDelete,
  isDeleting
}: FlexEBulkActionsProps) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const handleConfirmDelete = () => {
    onBulkDelete();
    setShowDeleteDialog(false);
  };

  if (selectedCount === 0) return null;

  return (
    <>
      <div className="flex items-center justify-between p-4 bg-primary/10 border border-primary/20 rounded-lg">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium">
            {selectedCount} simulatie{selectedCount > 1 ? 's' : ''} geselecteerd
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-7"
          >
            <X className="h-3 w-3 mr-1" />
            Wis selectie
          </Button>
        </div>
        
        <Button
          variant="destructive"
          size="sm"
          onClick={() => setShowDeleteDialog(true)}
          disabled={isDeleting || selectedCount > 20}
          title={selectedCount > 20 ? 'Maximaal 20 items tegelijk verwijderen' : undefined}
        >
          <Trash2 className="h-3 w-3 mr-2" />
          Verwijder geselecteerde
        </Button>
      </div>

      {selectedCount > 20 && (
        <p className="text-sm text-destructive px-4">
          ⚠️ Je kunt maximaal 20 simulaties tegelijk verwijderen. Verminder je selectie.
        </p>
      )}

      <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Weet je het zeker?</AlertDialogTitle>
            <AlertDialogDescription>
              Je staat op het punt om <strong>{selectedCount} simulatie{selectedCount > 1 ? 's' : ''}</strong> permanent te verwijderen.
              Deze actie kan niet ongedaan worden gemaakt.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuleren</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirmDelete}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            >
              Definitief verwijderen
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
